import type { MailboxInfo } from 'owa-client-types';
import {
    isEnabledForFrontierCopilotAudience,
    type FrontierFlightConfig,
} from './isEnabledForFrontierCopilotAudience';

const labsBarFrontierFlights: FrontierFlightConfig = {
    publicFlight: 'cal-ai-labs-bar-frontier-public',
    privateTapFlight: 'cal-ai-labs-bar-frontier-private-tap',
    privateStagingFlight: 'cal-ai-labs-bar-frontier-private-staging',
    privateInfluencerFlight: 'cal-ai-labs-bar-frontier-private-influencer',
};

/**
 * Returns true if the Calendar AI Labs Bar is enabled for the given mailbox.
 *
 * Enabled via either:
 *  - Frontier path: user is enrolled in a Frontier audience tier and the corresponding tier flight is on
 *
 * The Calendar AI Labs Bar has fully rolled out, so it is now always enabled.
 * This remains a function (rather than an inlined constant) so callers keep a
 * single, stable enablement seam.
 *
 * @param mailboxInfo Mailbox info for the account to check
 * @returns true if the feature is enabled, false otherwise
 */
export function isCalendarAILabsBarEnabled(mailboxInfo: MailboxInfo): boolean {
    return isEnabledForFrontierCopilotAudience(mailboxInfo, labsBarFrontierFlights);
}
